import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import "./style.css"

const PassowrdField = ({ field, placeholder, disabled }) => {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const { handleChange } = useFormikContext();

  return (
    <div className='pass-group'>
      <input
        {...field}
        type={isShowPassword ? 'text' : 'password'}
        onChange={handleChange}
        className='custom-input'
        name={field?.name}
        placeholder={placeholder}
        disabled={disabled}
      />
      <span
        onClick={() => setIsShowPassword(!isShowPassword)}
        className={`fas ${isShowPassword ? 'fa-eye-slash' : 'fa-eye'} toggle-password-custom`}
      />
    </div>
  );
};

export default PassowrdField;
